import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerSW } from "./swRegister";

// Patch: suppress harmless removeChild/insertBefore errors caused by
// browser extensions, mobile translate features, or PWA chromium quirks.
// These do NOT affect app functionality. (React issue #11538)
if (typeof Node !== 'undefined' && Node.prototype) {
  const origRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function(child) {
    if (child.parentNode !== this) {
      console.warn('removeChild: node is not a child — suppressed');
      return child;
    }
    return origRemoveChild.call(this, child);
  };

  const origInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function(newNode, refNode) {
    if (refNode && refNode.parentNode !== this) {
      console.warn('insertBefore: ref node is not a child — suppressed');
      return newNode;
    }
    return origInsertBefore.call(this, newNode, refNode);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerSW();
